import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import rootReducerCreator from '@/combineReducer';
import rootSagaCreator from '@/combineSaga';

import type { Reducer } from 'redux';
import type { RootState } from '@/rootState';

const isDevelopment = import.meta.env.MODE !== 'production';

const createLoggerMiddleware = () =>
	createLogger({
		level: 'info',
		collapsed: true,
	});

export const createAppStore = () => {
	const sagaMiddleware = createSagaMiddleware();
	const rootReducer = rootReducerCreator() as unknown as Reducer<RootState>;
	const store = configureStore({
		reducer: rootReducer,
		devTools: isDevelopment,
		middleware: (getDefaultMiddleware) => {
			const middlewares = getDefaultMiddleware({
				thunk: false,
				serializableCheck: false,
				immutableCheck: false,
			}).concat(sagaMiddleware);

			if (!isDevelopment) {
				return middlewares;
			}

			return middlewares.concat(createLoggerMiddleware());
		},
	});

	sagaMiddleware.run(rootSagaCreator);

	return store;
};

const store = createAppStore();

export type AppStore = ReturnType<typeof createAppStore>;
export type AppDispatch = AppStore['dispatch'];

export { store };
